import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private httpClient: HttpClient) {}

  public uploadProofImages(formData: FormData): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.apiUrl}/file/upload/proof_images`,
      formData
    );
  }

  public uploadFeedbackImages(formData: FormData): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.apiUrl}/file/upload/feedback`,
      formData
    );
  }
}
